import request from '@/utils/request'

let WifiApi = {
  packageList(data, errorback) {
    return request._postBody('/shop/iot/basicPackage/index', data, errorback);
  },
  addPackage(data, errorback) {
    return request._postBody('/shop/iot/basicPackage/add', data, errorback);
  },
  updatePackage(data, errorback) {
    return request._postBody('/shop/iot/basicPackage/update', data, errorback);
  },
  getPackageDetail(data, errorback) {
    return request._get('/shop/iot/basicPackage/detail', data, errorback);
  },
  deletePackage(data, errorback) {
    return request._postBody('/shop/iot/basicPackage/delete', data, errorback);
  },
  deviceList(data, errorback) {
    return request._postBody('/shop/iot/device/index', data, errorback);
  },
  importDevice(data, errorback) {
    return request._postBody('/shop/iot/device/importDevice', data, errorback);
  },
  userList(data, errorback) {
    return request._postBody('/shop/iot/user/index', data, errorback);
  },
  changeUserState(data, errorback) {
    return request._postBody('/shop/iot/user/changeState', data, errorback);
  },
  orderList(data, errorback) {
    return request._postBody('/shop/iot/order/index', data, errorback);
  },
  userFeedback(data, errorback) {
    return request._postBody('/shop/iot/userFeedback/index', data, errorback);
  },
  doProcess(data, errorback) {
    return request._postBody('/shop/iot/userFeedback/doProcess', data, errorback);
  },
  //修改会员wifi等级
  changeUserGrade(data, errorback) {
    return request._postBody('/shop/iot/grade/changeUserGrade', data, errorback);
  },
  noBuyDevice(data, errorback) {
    return request._postBody('/shop/iot/device/getList', data, errorback);
  },
  //wifi等级变更记录
  wifiUserGradeLog(data, errorback) {
    return request._get('/shop/iot/grade/wifiUserGradeLog', data, errorback);
  },
  deviceGrantPackage(data, errorback) {
    return request._postBody('/shop/iot/device/deviceGrantPackage', data, errorback);
  },
  unBindDevice(data, errorback) {
    return request._postBody('/shop/iot/device/unBindDevice', data, errorback);
  },

  // 消息列表
  getMessageList(data, err) {
    return request._get('/shop/iotMessage/pageList', data, err);
  },
  // 新增消息
  getAddMessage(data, err) {
    return request._postBody('/shop/iotMessage/addMessage', data, err);
  },
  // 删除消息
  getDelMessage(data, err) {
    return request._postBody('/shop/iotMessage/delMessage', data, err);
  },

  // 选择用户
  getUser(data, err) {
    return request._get('/shop/user/user/selectList', data, err);
  },

  // 消息详情
  getMessageDetail(data, err) {
    return request._get('/shop/iotMessage/getDetail', data, err);
  },
  // 小程序消息发送用户列表
  getUserList(data, err) {
    return request._get('/shop/iotMessage/getUserMessageDetail', data, err);
  },
}

export default WifiApi;



// WEBPACK FOOTER //
// ./src/api/wifi.js